import { ComponentType, isValidElement, ReactNode } from 'react'
import { RenderComponent } from '../types/react'

const isFunction = <T extends (...attrs: any[]) => any>(func?: T | unknown): func is T => {
  return typeof func === 'function'
}

const isFunctionComponent = <P = unknown,>(
  component: ComponentType<P> | ReactNode
): component is ComponentType<P> => {
  return (typeof component === 'function' || !isValidElement(component)) && component !== undefined
}

export const render = <T extends object>(
  Component: RenderComponent<T>,
  props: T
): ReactNode | Promise<ReactNode> => {
  if (!Component) return null
  if (isFunction(Component)) {
    return Component(props)
  }
  if (isValidElement<T>(Component)) {
    return Component
  }
  if (isFunctionComponent(Component)) {
    return <Component {...props} />
  }
  return null
}

export const renderChildren = <T extends object>(
  children: RenderComponent<T>,
  props: T
): ReactNode | Promise<ReactNode> => {
  return isFunction(children) ? children(props) : (children as ReactNode)
}
